import React from "react";
import { createPortal } from "react-dom";
import { Toaster } from "react-hot-toast";
import { AUTO_DISMISS_ALERT_MS, Z_INDEX_APP_NOTIFICATIONS_LAYER } from "constants/alert.constants";

export default function AppToaster() {
  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <Toaster
      position="top-right"
      containerStyle={{ zIndex: Z_INDEX_APP_NOTIFICATIONS_LAYER }}
      toastOptions={{
        duration: AUTO_DISMISS_ALERT_MS,
      }}
    />,
    document.body
  );
}
